import { render, staticRenderFns } from "./bindTag.vue?vue&type=template&id=3ffc1bf5&scoped=true"
import script from "./bindTag.vue?vue&type=script&lang=js"
export * from "./bindTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc1bf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffc1bf5')) {
      api.createRecord('3ffc1bf5', component.options)
    } else {
      api.reload('3ffc1bf5', component.options)
    }
    module.hot.accept("./bindTag.vue?vue&type=template&id=3ffc1bf5&scoped=true", function () {
      api.rerender('3ffc1bf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/bindTag.vue"
export default component.exports